export default {
      id: "settingsBackupRestore-usage",
      viewBox: "0 0 24 24",
      url: "assets/" + "sprite.svg#settingsBackupRestore-usage",
      toString: function () {
        return this.url;
      }
    }